'use strict';

const {
	div, button, input, select, option
} = require('iblokz-snabbdom-helpers');

const kinds = ['url', 'file'];

module.exports = ({
	kind = 'url',
	url = '',
	fileName = '',
	accept,
	multiple = false,
	onKind,
	onUrl,
	onFile,
	onClear
}) => div('.form-url-file', [
	select('.form-control.form-url-file-kind', {
		on: {change: ev => onKind(ev.target.value)}
	}, kinds.map(k => option({
		attrs: {value: k, selected: kind === k},
		props: {value: k, selected: kind === k}
	}, k))),
	kind === 'file'
		? div('.form-url-file-pick', [
			fileName
				? input('.form-control.form-url-file-name', {
					attrs: {
						type: 'text',
						value: fileName,
						readonly: true,
						size: 1,
						title: fileName
					},
					on: {
						click: ev => {
							const el = ev.target.parentNode.querySelector('input[type=file]');
							if (el) el.click();
						}
					}
				})
				: null,
			input(fileName ? '.form-url-file-native' : '.form-control.form-url-file-value', {
				key: fileName || 'pick',
				attrs: {
					type: 'file',
					accept: accept || undefined,
					multiple: multiple || undefined,
					title: fileName || 'Choose file'
				},
				style: fileName ? {display: 'none'} : {},
				on: {
					change: ev => {
						const files = Array.from((ev.target.files && ev.target.files) || []);
						ev.target.value = '';
						if (files.length) onFile(files);
					}
				}
			})
		].filter(Boolean))
		: input('.form-control.form-url-file-value', {
			attrs: {
				type: 'text',
				value: url || '',
				size: 1,
				placeholder: 'url'
			},
			on: {input: ev => onUrl(ev.target.value)}
		}),
	button('.form-url-file-clear.fa.fa-times[type="button"]', {
		attrs: {title: 'Clear'},
		on: {click: () => onClear()}
	})
]);
